import {post} from './';

export const orderCreate = (body) => {
  const url = '/api/order/create'
  return post(url, body)
}

export const placeAutocomplete = (body) => {
  const url = '/api/order/place-autocomplete'
  return post(url, body)
}

export const placeDetail = (body) => {
  const url = '/api/order/place-detail'
  return post(url, body)
}

export const getLocationName = (body) => {
  const url = '/api/order/get-location-name'
  return post(url, body)
}

export const listOrderTypes = (body) => {
  const url = '/api/order/list-order-type'
  return post(url, body)
}

export const getDistanceMoney = (body) => {
  const url = '/api/order/get-distance-money'
  return post(url, body)
}

export const calculateMoneyFromDistance = (body) => {
  const url = '/api/order/calculate-money-from-distance'
  return post(url, body)
}

export const listOrderHistory = (body) => {
  if (body.status && _.isArray(body.status) && body.status.length) {
    body.query = {
      status: {$in: body.status}
    }
    delete body.status
  }
  const url = '/api/order/orders-history-list'
  return post(url, body)
}

export const listOrderHistoryForShip = (body) => {
  if (body.status && _.isArray(body.status) && body.status.length) {
    body.query = {
      status: {$in: body.status}
    }
    delete body.status
  }
  const url = '/api/order/orders-history-list-for-ship'
  return post(url, body)
}

export const shopReject = (body) => {
  const url = '/api/order/shop-reject'
  return post(url, body)
}

export const shopRetry = (body) => {
  const url = '/api/order/shop-retry'
  return post(url, body)
}

export const getOrderDetail = (body) => {
  const url = '/api/order/get-order-detail'
  return post(url, body)
}

export const getOrderDetailForShip = (body) => {
  const url = '/api/order/get-order-detail-for-ship'
  return post(url, body)
}
export const getConfigWeightFeeOrder = (body) => {
  const url = '/api/order/get-config-weight-fee'
  return post(url, body)
}
export const getMemberCurrentLocation = (body) => {
  const url = '/api/shipper/get-latest-location'
  return post(url, body)
}

export const trackingOrder = (body) => {
  const url = '/api/track'
  return post(url, body)
}
export const trackingDownload = (body) => {
  const url = '/api/track-download'
  return post(url, body)
}
export const getPaymentMethod = (body) =>{
  const url = '/api/app/get-config-payment-method'
  return post(url, body)
}

